import React from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'
import { Child } from './RouteWizard'

export default {
  renderChild(child: Child, methods: UseFormReturn): Child {
    if (child == null || child === false) {
      return null
    }

    if (child.type === Controller) {
      return React.createElement(child.type, {
        ...{
          ...child.props,
          control: methods.control,
          key: child.props.name,
        },
      })
    }

    if (child.props?.name) {
      return React.createElement(child.type, {
        ...{
          ...child.props,
          register: methods.register,
          control: methods.control,
          key: child.props.name,
        },
      })
    }

    if (child.props?.children) {
      return React.createElement(child.type, {
        ...{
          ...child.props,
          children: this.renderChildren(child.props.children, methods),
        },
      })
    }

    return child
  },

  renderChildren(
    children: Child[] | Child,
    methods: UseFormReturn,
  ): Child[] | Child {
    if (!Array.isArray(children)) {
      return this.renderChild(children, methods)
    }

    const renderedChildren = React.Children.map(children, (child) => {
      return this.renderChild(child, methods)
    })

    if (renderedChildren) {
      return renderedChildren.flat()
    }
    return null
  },
}
